/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateOrDeleteLeadCommentReactionRequest
 */
export interface CreateOrDeleteLeadCommentReactionRequest {
    /**
     * 
     */
    user_id?: string;
    /**
     * 
     */
    reaction_type?: string;
}

/**
 * Check if a given object implements the CreateOrDeleteLeadCommentReactionRequest interface.
 */
export function instanceOfCreateOrDeleteLeadCommentReactionRequest(value: object): value is CreateOrDeleteLeadCommentReactionRequest {
    return true;
}

export function CreateOrDeleteLeadCommentReactionRequestFromJSON(json: any): CreateOrDeleteLeadCommentReactionRequest {
    return CreateOrDeleteLeadCommentReactionRequestFromJSONTyped(json, false);
}

export function CreateOrDeleteLeadCommentReactionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateOrDeleteLeadCommentReactionRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'user_id': json['user_id'] == null ? undefined : json['user_id'],
        'reaction_type': json['reaction_type'] == null ? undefined : json['reaction_type'],
    };
}

export function CreateOrDeleteLeadCommentReactionRequestToJSON(json: any): CreateOrDeleteLeadCommentReactionRequest {
    return CreateOrDeleteLeadCommentReactionRequestToJSONTyped(json, false);
}

export function CreateOrDeleteLeadCommentReactionRequestToJSONTyped(value?: CreateOrDeleteLeadCommentReactionRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'user_id': value['user_id'],
        'reaction_type': value['reaction_type'],
    };
}

